module.exports = __webpack_public_path__ + "img/album21_25.2d7e5807.jpg";